import { useId } from 'react';
import { BRAND } from '@rydres/shared';
import { markSvg } from './mark.js';

/**
 * The steering-wheel mark, beside the name unless `wordmark` is false ('brand' paints the name in
 * the gradient, for large sizes only). The mark follows the theme through the --t-mark-* tokens;
 * the name takes its size from `className` (text-sm, text-3xl...).
 */
export function Logo({ size = 28, wordmark = true, className = '' }: { size?: number; wordmark?: boolean | 'brand'; className?: string }) {
  const id = `m${useId().replace(/[^a-zA-Z0-9]/g, '')}`;
  const svg = markSvg({ size, theme: 'css', id, title: wordmark ? undefined : BRAND.name });
  return (
    <span className={`inline-flex items-center font-black leading-none tracking-tight ${className}`} style={{ gap: Math.round(size * 0.3) }}>
      {/* Our own drawing from constants, never user text. */}
      <span className="flex shrink-0" dangerouslySetInnerHTML={{ __html: svg }} />
      {wordmark && <span className={wordmark === 'brand' ? 'text-brand' : 'text-ink'}>{BRAND.name}</span>}
    </span>
  );
}
